import React, { cloneElement } from 'react';
import {
  Button,
  Col,
  Row,
  Form,
  Table,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import { MdDone, MdClear, MdCreate, MdSearch } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import CrmCampaignForm from '../components/CrmCampaignForm';
import PosProductForm from '../components/PosProductForm';
import SearchInput from '../components/SearchInput';
import { BsPlusSquareFill } from 'react-icons/bs';
import { IconContext } from 'react-icons/lib';

class CrmCampaignTable extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      isGlobal: '',
      dataList: [],
      filteredList: [],
      redirect: false,
      selectedId: '',
      selectedData: '',
      searchKey: '',
    };
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info');
    //if (user.superUser) {
    this.getData();
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getData();
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  sortData() {
    const { customerList, sortKey } = this.state;
    if (sortKey.length) {
      customerList.sort((a, b) => a[sortKey] - b[sortKey]).reverse();
      this.setState({ customerList });
    } else {
      this.getCustomerList();
    }
  }

  searchChange = event => {
    const searchKey = event.target.value.toLowerCase();
    this.setState({ searchKey }, () => this.filteredList());
  };

  filteredList = () => {
    let customerList = this.state.customerList;
    let searchKey = this.state.searchKey;

    let customers = customerList.filter(customer => {
      return (
        customer.name.toLowerCase().indexOf(searchKey) != -1 ||
        customer.serial.toLowerCase().indexOf(searchKey) != -1 ||
        customer.model.toLowerCase().indexOf(searchKey) != -1 ||
        customer.unit.toLowerCase().indexOf(searchKey) != -1 ||
        customer.postal_code.toLowerCase().indexOf(searchKey) != -1 ||
        customer.install_date.toLowerCase().indexOf(searchKey) != -1
      );
    });
    this.setState({ filteredList: customers });
  };

  getData = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_API_URL;
    const data = {
      session_key: user.session_key,
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3001/v1/broadcast', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            dataList: result.data,
            filteredList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  detail = id => {
    this.props.history.push({
      pathname: `/crmcampaign/${id}`,
    });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    const customerList = this.state.dataList.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.broadcast_subject}</td>
          <td>{item.broadcast_date} &nbsp;22:00:00</td>
          <td>
            <span
              className={'ps-indicator ' + (item.ready == '1' ? 'on' : 'off')}
            >
              {item.ready == '1' ? 'Yes' : 'No'}
            </span>
          </td>
          <td>
            <div className="ps-action-button">
              <Button
                className="theme-button theme-button-secondary"
                onClick={() => this.detail(item.broadcast_id)}
              >
                View
              </Button>
            </div>
          </td>
        </tr>
      );
    });

    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <div className="text-right mb-3">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>

        <Table responsive hover className="ps-table tb-col-9 th-no-wrap">
          <thead>
            <tr>
              <th>Subject</th>
              <th>Schedule Date</th>
              <th>Ready</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {customerList.length < 1 ? (
              <tr>
                <td colSpan="9">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>
                        Click the {this.state.isGlobal ? 'Create' : 'Add'}{' '}
                        button to add new broadcast
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              customerList
            )}
          </tbody>
        </Table>

        <Modal
          isOpen={this.state.modal}
          // toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <CrmCampaignForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>

        {/* <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            {this.state.isGlobal ? 'Delete' : 'Remove'} Product
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to{' '}
                  {this.state.isGlobal ? 'delete' : 'remove'}{' '}
                  {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              Discard
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Confirm
            </Button>
          </ModalFooter>
        </Modal> */}
      </>
    );
  }
}
export default CrmCampaignTable;
